interface Theme {
  logo: string;
  theme: { primary: string; accent: string };
}

export interface PracticeData extends Theme {
  uuid: string;
  name: string;
  contact_numbers: string[];
  email_addresses: string[];
  terms_and_conditions: string;
  slogan?: string;
  website?: string;
  booking_redirect?: string;
  enable_online_booking_reason?: boolean;
}

export class Practice {
  uuid: string;
  name: string;
  contactNumbers: string[];
  emailAddresses: string[];
  logo: string;
  slogan: string;
  website: string;
  bookingRedirect: string;
  enableOnlineBookingReason: boolean;
  termsAndConditions: string;
  theme: { primary: string; accent: string };
  rosteredSettings: {
    rostered_dairy: boolean;
    rostered_name: string;
    id_field_description: string;
    explanation: string;
  };

  constructor(data: PracticeData) {
    this.uuid = data.uuid;
    this.name = data.name;
    this.contactNumbers = data.contact_numbers;
    this.emailAddresses = data.email_addresses;
    this.logo = data.logo;
    this.termsAndConditions = data.terms_and_conditions;
    this.theme = data.theme;
    this.slogan = data.slogan;
    this.website = data.website;
    this.bookingRedirect = data.booking_redirect;
    this.enableOnlineBookingReason = data.enable_online_booking_reason;
  }
}
